/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Card_DescInputs */

const en_login_card_desc = /** @type {(inputs: Login_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your credentials to continue.`)
};

const de_login_card_desc = /** @type {(inputs: Login_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzen Sie Ihre Zugangsdaten, um fortzufahren.`)
};

/**
* | output |
* | --- |
* | "Use your credentials to continue." |
*
* @param {Login_Card_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_card_desc = /** @type {((inputs?: Login_Card_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Card_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_card_desc(inputs)
	return en_login_card_desc(inputs)
});